import apiV2 from '../api/v2';
import { toApiError } from './apiErrors';

export interface UpdateDesignPreferencesResult {
    designPreferences: string | null;
}

export async function updatePracticeDesignPreferences(
    practiceId: string,
    designPreferences: string | null
): Promise<UpdateDesignPreferencesResult> {
    try {
        const response = await apiV2.put<{ success: boolean; data: UpdateDesignPreferencesResult }>(
            `/practices/${practiceId}/design-preferences`,
            { designPreferences }
        );
        return response.data.data;
    } catch (err) {
        throw toApiError(err);
    }
}
